// src/features/projectsSlice.js
import { createSlice } from '@reduxjs/toolkit';

const notiSlice = createSlice({
  name: 'noti',
  initialState: {
    notiList: [],
    notiStatus: 'idle',
    notiError: null
  },
  reducers: {
    setNoti: (state, action) => {
      console.log('Setting Noti in slice:', action.payload);
      state.notiList = action.payload;
      state.notiStatus = 'succeeded';
      state.notiError = null;
    },
    setNotiError: (state, action) => {
      state.notiError = action.payload;
      state.notiStatus = 'failed';
    },
    clearNoti: (state) => {
      state.notiList = [];
      state.notiStatus = 'idle';
      state.notiError = null;
    }
  }
});

export const { setNoti, setNotiError, clearNoti } = notiSlice.actions;

// export const selectProjectsStatus = (state) => state.projects.status;
// export const selectProjectsError = (state) => state.projects.error;

export default notiSlice.reducer;